var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.5 26.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#47474a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Expanded_No_box",
    "data-name": "Expanded \\u2013 No box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.25,1.5A11.75,11.75,0,1,0,25,13.25,11.76,11.76,0,0,0,13.25,1.5ZM14,19.23a.75.75,0,1,1-1.5,0V12.08a.75.75,0,1,1,1.5,0Zm-.75-9.75a1.11,1.11,0,1,1,1.1-1.1A1.1,1.1,0,0,1,13.25,9.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.25,0A13.25,13.25,0,1,0,26.5,13.25,13.26,13.26,0,0,0,13.25,0Zm0,25A11.75,11.75,0,1,1,25,13.25,11.76,11.76,0,0,1,13.25,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.25,11.33a.75.75,0,0,0-.75.75v7.15a.75.75,0,1,0,1.5,0V12.08A.74.74,0,0,0,13.25,11.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.25,7.27a1.11,1.11,0,1,0,1.1,1.11A1.11,1.11,0,0,0,13.25,7.27Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoDefault);
export default __webpack_public_path__ + "static/media/info-default.92603c44f28dfd993f6a4481115e0cd4.svg";
export { ForwardRef as ReactComponent };